import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { relocationPageRecordQuery } from "@/app/Settings/Admin/RelocationPages/GraphQL/relocationPageRecordQuery";
import { useSearch } from "@tanstack/react-router";

export function useRelocationPageDrawer() {
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}",
  });

  if (!search.relocationPageId) {
    throw new Error("Relocation page id is not present in the search params");
  }

  const { data } = useSuspenseGqlQuery(relocationPageRecordQuery, {
    id: search.relocationPageId,
  });

  return data.relocationPageById;
}
